// we do not support select and search bar yet
const focusableCustomElements = [
  'tt-button',
  'tt-dropdown',
  'tt-checkbox',
  'tt-radio',
  'tt-range',
  'tt-option',
  'tt-text-area',
  'tt-text-field',
  'tt-toggle',
  'tt-icon-button',
  'tt-action-card',
  'tt-menu-item',
  'tt-tab',
  'tt-pane-navigation',
];
const focusableDomElements = [
  'a[href]',
  'button',
  'input',
  'textarea',
  'select',
  'details',
  '[tabindex]:not([tabindex="-1"])',
];
function isFocusableCustomElement(element) {
  return (focusableCustomElements.includes(element.tagName.toLowerCase()) &&
    window.getComputedStyle(element).visibility !== 'hidden');
}
function isFocusableDomElement(element) {
  return element.matches(focusableDomElements.join(',')) && window.getComputedStyle(element).visibility !== 'hidden';
}
function getFocusables(elements) {
  const focusables = [];
  elements.forEach((element) => {
    if (isFocusableCustomElement(element)) {
      focusables.push(element);
    }
    else if (isFocusableDomElement(element)) {
      element.setFocus = element.focus;
      focusables.push(element);
    }
    else {
      const focusableQuery = `${focusableCustomElements.join(',')},${focusableDomElements.join(',')}`;
      const focusableChildren = Array.from(element.querySelectorAll(focusableQuery)).filter((focusableElement) => {
        const elementHidden = window.getComputedStyle(focusableElement).visibility === 'hidden';
        const elementInert = focusableElement.closest('[inert]') !== null;
        return !(elementHidden || elementInert);
      });
      focusableChildren.forEach((focusableChild) => {
        if (isFocusableDomElement(focusableChild)) {
          focusableChild.setFocus = focusableChild.focus;
        }
      });
      focusables.push(...focusableChildren);
      const nestedSlottedFocusableElements = getFocusables(Array.from(element.querySelectorAll('slot')).flatMap((slot) => slot.assignedElements({ flatten: true })));
      focusables.push(...nestedSlottedFocusableElements);
    }
  });
  return focusables;
}
function convertToFocusableElement(element) {
  if (isFocusableCustomElement(element)) {
    return element;
  }
  else if (isFocusableDomElement(element)) {
    element.setFocus = element.focus;
    return element;
  }
  return null;
}
function getFocusableElementsFromSlot(slot) {
  const elements = slot.assignedElements({ flatten: true });
  return getFocusables(elements);
}
function getFirstFocusableElementFromSlot(slot) {
  const focusables = getFocusableElementsFromSlot(slot);
  if (focusables.length === 0) {
    return null;
  }
  return focusables[0];
}
function getLastFocusableElementFromSlot(slot) {
  const focusables = getFocusableElementsFromSlot(slot);
  if (focusables.length === 0) {
    return null;
  }
  return focusables[focusables.length - 1];
}

export { getLastFocusableElementFromSlot as a, convertToFocusableElement as c, getFirstFocusableElementFromSlot as g };
